<header class="onboarding-header">
  <div class="onboarding-header-inner">
    <a routerLink="/" class="logo" aria-label="Purposeful for Teams">
      <svg-icon class="logo-icon" src="/assets/logo/purposeful-teams-white.svg"></svg-icon>
    </a>
    <ki-onboarding-stepper class="stepper-slot"></ki-onboarding-stepper>
    <div class="logo-spacer" aria-hidden="true"></div>
  </div>
</header>
